import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

function ProgressBar({ duration, vertical = false, animationClass }) {
	const progressRef = useRef();
	useEffect(() => {
		progressRef.current.style.setProperty('animation-duration', `${duration}s`, 'important');
	}, [duration]);

	if (vertical) {
		return (
			<div className="h-full bg-aqua-haze rounded-full w-2.5">
				<div ref={progressRef} className={classNames('bg-mariner rounded-full ', animationClass)} />
			</div>
		);
	}
	return (
		<div className="w-full bg-aqua-haze rounded-full h-2.5">
			<div ref={progressRef} className={classNames('bg-mariner h-2.5 rounded-full ', animationClass)} />
		</div>
	);
}

export default ProgressBar;
